import type { ColumnDef } from './types'

export const columnDefinitions: ColumnDef[] = [
  { key: 'product_code', label: 'رمز الصنف', minWidth: 50 },
  { key: 'product_name', label: 'اسم الصنف', minWidth: 80 },
  { key: 'serial_number', label: 'رقم المسلسل', minWidth: 65 },
  { key: 'quantity', label: 'العدد', minWidth: 40 },
  { key: 'carat', label: 'العيار', minWidth: 40 },
  { key: 'unit', label: 'الوحدة', minWidth: 50 },
  { key: 'weight', label: 'كمية / وزن', minWidth: 55 },
  { key: 'stone_weight', label: 'وزن الفص', minWidth: 55 },
  { key: 'unit_price', label: 'سعر البيع', minWidth: 60 },
  { key: 'salary', label: 'الأجور', minWidth: 50 },
  { key: 'total_salary', label: 'إجمالي الأجور', minWidth: 70 },
  { key: 'tax_rate', label: 'نسبة الضريبة', minWidth: 60 },
  { key: 'discount', label: 'الخصم', minWidth: 45 },
  { key: 'total', label: 'الإجمالي', minWidth: 65 },
  { key: 'actions', label: 'العمليات', minWidth: 40 }
]

export type ColumnVisibilityConfig = Record<string, boolean>

export const defaultColumnConfig: ColumnVisibilityConfig = {
  product_code: true,
  product_name: true,
  serial_number: false,
  quantity: true,
  carat: true,
  unit: false,
  weight: true,
  stone_weight: false,
  unit_price: true,
  salary: false,
  total_salary: false,
  tax_rate: true,
  discount: true,
  total: true,
  actions: true
}

export const essentialColumnConfig: ColumnVisibilityConfig = {
  product_code: true,
  product_name: true,
  serial_number: false,
  quantity: true,
  carat: false,
  unit: false,
  weight: false,
  stone_weight: false,
  unit_price: true,
  salary: false,
  total_salary: false,
  tax_rate: false,
  discount: false,
  total: true,
  actions: true
}
